import { inject } from "@angular/core";
import { ResolveFn, ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { Observable, EMPTY, switchMap, take } from "rxjs";
import { environment } from "src/environments/environment";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { ResolverHelper } from "./resolver.helper";

export const EstimateResolver: ResolveFn<any> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> => {
    const authService = inject(AuthService);
    const router = inject(Router);
    const queryParams = route.queryParams;
    const hasUnitId = queryParams.hasOwnProperty("unitId") || queryParams.hasOwnProperty("unitID");

    return ResolverHelper.hasPermission(authService, [EVServiceType.EvWeb_Estimate2021]).pipe(
        take(1),
        switchMap((hasEstimate2021Role) => {
            if (!hasEstimate2021Role) {
                return redirectToSearchPage();
            }
            if (hasUnitId) {
                const unitId: string =
                    queryParams["unitId"] != null ? queryParams["unitId"].toString() : queryParams["unitID"] != null ? queryParams["unitID"].toString() : "";
                const url = environment.evwebUrl + "/infopage/shareinfo?eUnitId=" + unitId;
                window.open(url, "_self");
            }
            return EMPTY;
        }),
    );

    function redirectToSearchPage() {
        console.log("Redirecting to search page due to missing permissions or parameters");
        let queryString = "";
        if (hasUnitId) {
            const unitId: string =
                queryParams["unitId"] != null ? queryParams["unitId"].toString() : queryParams["unitID"] != null ? queryParams["unitID"].toString() : "";
            queryString = "u" + unitId;
        } else {
            return ResolverHelper.redirectToFrontPage(authService, router);
        }

        const url = environment.evwebUrl + "/searchpage;searchString=" + queryString + ";doSearch=true;";
        window.open(url, "_self");
        return EMPTY;
    }
};
